import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "nav-header"
};
const _hoisted_2 = {
  key: 0,
  class: "header-left-title"
};
const _hoisted_3 = {
  class: "header-title"
};
const _hoisted_4 = {
  class: "header-right-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconCommonArrowLeft = _resolveComponent("IconCommonArrowLeft");

  return _openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("div", {
    class: "header-left",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.back && _ctx.back(...args))
  }, [_renderSlot(_ctx.$slots, "header-left", {}, () => [_createVNode(_component_IconCommonArrowLeft, {
    class: "header-left-icon"
  }), _ctx.$props.showBackTitle ? (_openBlock(), _createElementBlock("span", _hoisted_2, "返回")) : _createCommentVNode("", true)])]), _renderSlot(_ctx.$slots, "header-center", {}, () => [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "header-right")]), _renderSlot(_ctx.$slots, "header-bottom")]);
}